import { arrayRemove, arrayUnion, collection, doc, getDocs, getDoc, query, updateDoc, where } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import { db } from "../firebase";

export default function useMatches(currentUid) {
	const [matchedUids, setMatchedUids] = useState(new Set());
	const [theyMatchedMeUids, setTheyMatchedMeUids] = useState(new Set());
	const [loading, setLoading] = useState(true);

	const fetchMatches = useCallback(async () => {
		if (!currentUid) return;
		try {
			// People I matched
			const myRef = doc(db, "users", currentUid);
			const mySnap = await getDoc(myRef);
			const iMatched = mySnap.data()?.matches || [];
			setMatchedUids(new Set(iMatched));

			// People who matched me
			const snap = await getDocs(query(collection(db, "users"), where("matches", "array-contains", currentUid)));
			setTheyMatchedMeUids(new Set(snap.docs.map((d) => d.id)));
		} catch (err) {
			console.error("useMatches error:", err);
		} finally {
			setLoading(false);
		}
	}, [currentUid]);

	useEffect(() => {
		fetchMatches();
	}, [fetchMatches]);

	const isMutualWith = (uid) => matchedUids.has(uid) && theyMatchedMeUids.has(uid);
	const iHaveMatchedThem = (uid) => matchedUids.has(uid);
	const theyHaveMatchedMe = (uid) => theyMatchedMeUids.has(uid);

	const match = async (uid) => {
		const myRef = doc(db, "users", currentUid);
		await updateDoc(myRef, { matches: arrayUnion(uid) });
		setMatchedUids((prev) => new Set([...prev, uid]));
	};

	const unmatch = async (uid) => {
		const myRef = doc(db, "users", currentUid);
		await updateDoc(myRef, { matches: arrayRemove(uid) });
		setMatchedUids((prev) => {
			const next = new Set(prev);
			next.delete(uid);
			return next;
		});
	};

	return {
		matchedUids,
		theyMatchedMeUids,
		isMutualWith,
		iHaveMatchedThem,
		theyHaveMatchedMe,
		match,
		unmatch,
		loading,
		refresh: fetchMatches,
	};
}
